// The three languages the product is authored in, in ONE place.
//
// Endonyms — each language named in itself — plus a short code for a button
// face. Deliberately NOT run through t(): a language's own name is the one
// string that must never be translated, or a reader who does not speak the
// current UI language cannot find their way out of it.
//
// Order is kk, ru, en (state language first), matching SUPPORTED_LANGUAGES in
// i18n.js. Lives here rather than in i18n.js because importing that module
// INITIALISES i18next as a side effect, and the template editor needs the list
// without booting the whole i18n stack.
export const LANGUAGES = [
  { id: "kk", name: "Қазақша", code: "ҚАЗ" },
  { id: "ru", name: "Русский", code: "РУС" },
  { id: "en", name: "English", code: "ENG" },
];

export const LANGUAGE_IDS = LANGUAGES.map((l) => l.id);

// Display fallback for authored content, mirroring the backend's
// MODELTRANSLATION_FALLBACK_LANGUAGES: a missing Kazakh string is more useful
// to a Kazakhstani reader in Russian than in English. The trailing entries make
// the chain total — an authoring surface that renders blank when SOME language
// holds the text tells the author nothing about which one is missing, and the
// coverage badges are what report the real gaps.
export const CONTENT_FALLBACK = {
  kk: ["kk", "ru", "en"],
  ru: ["ru", "en", "kk"],
  en: ["en", "ru", "kk"],
};
